import { X } from "lucide-react";

/**
 * The × in the corner of a dialog.
 *
 * HQ-A11Y-002. Forty icon-only buttons across HQ rendered an X, a RotateCcw or
 * a bare × with no aria-label, aria-labelledby or title, so their accessible
 * name was either missing or the literal character "×" — which tells a screen
 * reader user nothing. Twenty of them were this exact control, written out by
 * hand each time in one of four spellings.
 *
 * Standardising it is the audit's own suggestion, and it is the only fix that
 * holds: the next dialog inherits the name instead of having to remember it.
 *
 * `label` takes a more specific name where one helps — "Close without saving"
 * on a form with unsaved work reads better than "Close" — but the default is
 * always a real name rather than a glyph.
 */
export function CloseButton({
  onClick,
  label = "Close",
  disabled,
  className = "text-gray2 hover:text-charcoal",
}: {
  onClick: () => void;
  label?: string;
  disabled?: boolean;
  className?: string;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      aria-label={label}
      className={className}
    >
      {/* Decorative: the button already carries the name, and announcing the
          icon as well would say it twice. */}
      <X size={18} aria-hidden="true" />
    </button>
  );
}
